import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '@shared/shared.module';
import { PrivateRoutingModule } from './private-routing.module';
import { PrivateComponent } from './private.component';
import { SettingsModule } from './settings/settings.module';
import { ResetPasswordComponent } from './reset-password/reset-password.component';


@NgModule({
  declarations: [
    PrivateComponent,
    ResetPasswordComponent

  ],
  imports: [
    CommonModule,
    SharedModule,
    PrivateRoutingModule,
    SettingsModule
  ]
})
export class PrivateModule { }
